module.exports = __webpack_public_path__ + "static/sprite-2d3d-8eaff6b6a154ff23b7103da7f8522a22.png";